/**
 * 权限管理工具类
 */

// 角色权限映射
const ROLE_ROUTES = {
  teacher: "/teacher",
  student: "/student",
  admin: "/admin",
  default: "/student", // 默认角色路由
};

// 角色权限配置
const ROLE_PERMISSIONS = {
  teacher: ["course_manage", "student_manage", "ai_assistant"],
  student: ["course_view", "exam_take"],
  admin: ["all"],
};

/**
 * 根据角色获取对应的路由
 * @param {Array} roles - 用户角色数组
 * @returns {string} 对应的路由路径
 */
export function getRouteByRoles(roles) {
  if (!roles || !Array.isArray(roles) || roles.length === 0) {
    return ROLE_ROUTES.default;
  }

  // 按优先级排序：admin > teacher > student
  const rolePriority = ["admin", "teacher", "student"];

  for (const role of rolePriority) {
    if (roles.includes(role)) {
      return ROLE_ROUTES[role] || ROLE_ROUTES.default;
    }
  }

  return ROLE_ROUTES.default;
}

/**
 * 检查用户是否有指定权限
 * @param {Array} userRoles - 用户角色数组
 * @param {string} permission - 需要检查的权限
 * @returns {boolean} 是否有权限
 */
export function hasPermission(userRoles, permission) {
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }

  return userRoles.some((role) => {
    const permissions = ROLE_PERMISSIONS[role];
    return (
      permissions &&
      (permissions.includes(permission) || permissions.includes("all"))
    );
  });
}

/**
 * 检查用户是否有指定角色
 * @param {Array} userRoles - 用户角色数组
 * @param {string|Array} requiredRoles - 需要的角色
 * @returns {boolean} 是否有角色
 */
export function hasRole(userRoles, requiredRoles) {
  if (!userRoles || !Array.isArray(userRoles)) {
    return false;
  }

  const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles];
  return userRoles.some((role) => roles.includes(role));
}

/**
 * 获取用户最高权限角色
 * @param {Array} roles - 用户角色数组
 * @returns {string} 最高权限角色
 */
export function getHighestRole(roles) {
  if (!roles || !Array.isArray(roles) || roles.length === 0) {
    return "student";
  }

  const rolePriority = ["admin", "teacher", "student"];

  for (const role of rolePriority) {
    if (roles.includes(role)) {
      return role;
    }
  }

  return "student";
}
